import { FC } from 'react';
import { HiPlus } from 'react-icons/hi';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/lib';
import RouteConstants from '@/features/router/RouteConstants';

export const SmsCampaignPrerequisiteBanner: FC = () => {
  const { t } = useTranslation('campaign');
  const history = useHistory();

  return (
    <div className='flex flex-col gap-3 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between'>
      <p className='text-sm text-blue-800'>{t('smsWorkspace.campaigns.createDisabledBannerNoTemplates')}</p>
      <Button
        intent='secondary'
        size='sm'
        className='inline-flex shrink-0 items-center gap-2'
        onClick={() => history.push(RouteConstants.createSmsTemplate)}
      >
        <HiPlus className='size-4' />
        {t('smsWorkspace.campaigns.createDisabledBannerNoTemplatesAction')}
      </Button>
    </div>
  );
};
